import { html } from 'lit-element';

import connect from '@elab/core/store/connect';
import { actions as globalActions } from '@elab/core/store/global';

import FormButton from './FormButton';
import actions from './Form/redux/actions';

export class WizardPrev extends FormButton {
    handleClick(evt) {
        if (evt) {
            evt.preventDefault();
        }

        if (this.step > 1) {
            this.dispatchEvent(new CustomEvent('GO_TO_PREV_STEP'));
        } else {
            this.dispatchEvent(new CustomEvent('GO_BACK'));
        }

        return false;
    }

    render() {
        const { classModifier = '' } = this;
        return html`
            <e2-button
                @click=${this.handleClick}
                class-modifier="${classModifier} ${this.step === 1
                    ? 'button--prev-first-step'
                    : ''}"
                ?no-arrow="${this.noArrow}"
                button-label="${this.buttonLabel}"
            >
            </e2-button>
        `;
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    GO_TO_PREV_STEP: () => {
        dispatch(actions.setStepBack(ctx.storeName));
    },
    GO_BACK: () => {
        dispatch(globalActions.goBack());
    },
});

export default () =>
    customElements.define('e2-wizard-prev', connect(null, mapDispatchToEvents)(WizardPrev));
